import { render, staticRenderFns } from "./MudarStatusPedido.vue?vue&type=template&id=0cbf7749"
import script from "./MudarStatusPedido.vue?vue&type=script&lang=js"
export * from "./MudarStatusPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports